export function arrInfIndex<T>(arr: T[], index: number): T {
  if (index < arr.length) {
    return arr[index];
  }
  return arr[index % arr.length];
}

export function rand(min: number, max: number): number {
  return Math.random() * (max - min) + min;
}

//TODO: Update this to an extended HTML element
export function hasBeenInitialised(element: any, initKey: string) {
  if (!element.gbginits) return false;
  return element.gbginits.indexOf(initKey) > -1;
}

//TODO: Update this to an extended HTML element
export function markInitialised(element: any, initKey: string) {
  if (!element.gbginits) {
    element.gbginits = [];
  }
  if (!hasBeenInitialised(element, initKey)) {
    element.gbginits.push(initKey);
  }
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function kebabToJS(kebabCase: string): string {
  return kebabCase
    .split("-")
    .map((curr, index) => {
      return index > 0 ? curr.charAt(0).toUpperCase() + curr.slice(1) : curr;
    })
    .join("");
}

export function toHtmlId(s: string): string {
  return s.replace(/\W/g, "_");
}

export function attachResources(
  resources: string[],
  callback?: () => void
): void {
  let scriptCount = resources.filter((r) => r.endsWith(".js")).length;
  let c = 0;
  let loadedCallback = () => {
    c++;
    if (c == scriptCount) {
      callback();
    }
  };

  resources.forEach((url) => {
    if (url.endsWith(".css")) {
      var link = document.createElement("link");
      link.href = url;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    } else if (url.endsWith(".js")) {
      var script = document.createElement("script");
      script.src = url;
      if (callback) {
        script.onload = loadedCallback;
      }
      document.head.appendChild(script);
    } else {
      throw "Unrecognised file type.";
    }
  });
}

export interface DatetimeProps {
  d: Date;
  options?: Intl.DateTimeFormatOptions;
}

export const formatDateTime = ({ d, options }: DatetimeProps) => {
  const formatter = new Intl.DateTimeFormat(undefined, options);
  return formatter.format(d);
};

export default {
  markInitialised,
  hasBeenInitialised,
  rand,
  arrInfIndex,
  kebabToJS,
  toHtmlId,
  sleep,
  formatDateTime,
};
